export const defData = {
  words: 5,
  type: 'any',
  lexemes: [
    {
      lexeme: 'nzi',
      definition: 'tree'
    },
    {
      lexeme: 'ilu',
      definition: 'flower'
    },
    {
      lexeme: 'ru',
      definition: 'person'
    },
    {
      lexeme: 'kwərə',
      definition: 'goat'
    },
    {
      lexeme: 'lɛtsi',
      definition: 'sword'
    }
  ],
  derivations: [
    {
      derivation: '-vo',
      gloss: 'person',
      definition:
        'Creates a noun referring to a person associated with the base.'
    },
    {
      derivation: '-lu',
      gloss: 'place',
      definition: 'Creates a noun denoting the location of the base.'
    },
    {
      derivation: 'ña-',
      gloss: 'abstract',
      definition: 'Creates an abstract noun.'
    },
    {
      derivation: 'k-sa',
      gloss: 'collective',
      definition: 'Creates a noun referring to a collection of bases.'
    }
  ],
  results: undefined
}
